const FEED_API_ARTIFACT_OBJECT_ID = 17;
const FEED_API_BFP_OBJECT_ID = 13;

const FEED_API = '/feed-api/v1';
const ISLAND_API = '/island-api/v1';

const MAX_AGE_LONG = 86400;
const MAX_AGE_SHORT = 60; // 1 min

module.exports = {
  FEED_API,
  FEED_API_ARTIFACT_OBJECT_ID,
  FEED_API_BFP_OBJECT_ID,
  ISLAND_API,
  MAX_AGE_LONG,
  MAX_AGE_SHORT
};
